import { jsx as _jsx } from "react/jsx-runtime";
import { HomeFaireMarketFooter } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Banner/ByType/HomeFaireMarketFooter";
import { HomeFaireMarketHero } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Banner/ByType/HomeFaireMarketHero";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import React from "react";
export var HomeFaireMarketBanner = function() {
    var _React_useContext = React.useContext(Context), layoutElement = _React_useContext.layoutElement, onCTAClick = _React_useContext.onCTAClick, requestId = _React_useContext.requestId;
    var onClick = function() {
        var _layoutElement_on_click_event_name;
        onCTAClick === null || onCTAClick === void 0 ? void 0 : onCTAClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "HomeFaireMarketBanner", requestId);
    };
    switch(layoutElement.on_click_event_name){
        case "homepage_market_banner_hero":
            return /*#__PURE__*/ _jsx(HomeFaireMarketHero, {
                onClick: onClick,
                layoutElement: layoutElement
            });
        case "homepage_market_banner_footer":
            return /*#__PURE__*/ _jsx(HomeFaireMarketFooter, {
                onClick: onClick
            });
        default:
            return null;
    }
};
